import { useTranslation } from 'react-i18next';

type AdminUsersTab = 'users' | 'groups';

interface AdminUsersPageHeaderProps {
  activeTab: AdminUsersTab;
  canManageGroups: boolean;
  onTabChange: (tab: AdminUsersTab) => void;
  onInviteUser: () => void;
  onCreateGroup: () => void;
}

export const AdminUsersPageHeader = ({
  activeTab,
  canManageGroups,
  onTabChange,
  onInviteUser,
  onCreateGroup,
}: AdminUsersPageHeaderProps) => {
  const { t } = useTranslation();

  const tabClassName = (tab: AdminUsersTab) =>
    `px-6 py-3 text-sm font-medium border-b-2 transition ${
      activeTab === tab
        ? 'border-primary text-primary'
        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
    }`;

  return (
    <>
      <div className="p-6 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-display text-primary mb-2">{t('admin.users.title')}</h1>
          <p className="text-secondary">{t('admin.users.subtitle')}</p>
        </div>
        {activeTab === 'users' ? (
          <button
            onClick={onInviteUser}
            className="px-4 py-2 bg-primary text-white rounded-md hover:bg-opacity-90 transition whitespace-nowrap self-start sm:self-auto"
          >
            {t('admin.users.invite_button')}
          </button>
        ) : (
          canManageGroups && (
            <button
              onClick={onCreateGroup}
              className="px-4 py-2 bg-primary text-white rounded-md hover:bg-opacity-90 transition whitespace-nowrap self-start sm:self-auto"
            >
              {t('admin.groups.create_button')}
            </button>
          )
        )}
      </div>

      <div className="border-b border-gray-200">
        <nav className="flex -mb-px">
          <button onClick={() => onTabChange('users')} className={tabClassName('users')}>
            {t('admin.tabs.users')}
          </button>
          <button onClick={() => onTabChange('groups')} className={tabClassName('groups')}>
            {t('admin.tabs.groups')}
          </button>
        </nav>
      </div>
    </>
  );
};
